// src/components/ui/cards/PartnerServiceDetailsCard/PartnerServiceDetailsCardShadcn.jsx
import React from 'react';
import { DollarSign, Clock } from 'lucide-react';

// shadcn components
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../card';

import { cn } from '../../../../utils/cn';

const PartnerServiceDetailsCardShadcn = ({
  service,
  className = ""
}) => {
  const formatPrice = (price) => {
    if (!price && price !== 0) return 'Not set';
    return `$${parseFloat(price).toFixed(2)}`;
  };

  const formatDuration = (minutes) => {
    if (!minutes) return 'Not set';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
  };

  return (
    <Card className={cn(
      "rounded-xl border transition-all duration-200",
      "bg-slate-700/30 border-slate-600/30",
      className
    )}>
      <CardContent className="p-4">
        {/* Service Header */}
        <div className="flex items-center gap-3 mb-3">
          {/* Color Indicator */}
          <div
            className="w-3 h-3 rounded-full border border-slate-600"
            style={{ backgroundColor: service.color_code || '#8B5CF6' }}
          />

          {/* Service Name */}
          <h4 className="font-semibold text-slate-200 truncate">
            {service.label}
          </h4>
        </div>

        {/* Description */}
        {service.description && (
          <p className="text-slate-400 text-sm mb-3 line-clamp-2">
            {service.description}
          </p>
        )}

        {/* Service Details */}
        <div className="flex items-center gap-4 text-sm">
          {/* Duration */}
          <div className="flex items-center gap-2 text-slate-300">
            <Clock className="w-4 h-4 text-blue-400" />
            <span className="font-medium">
              {formatDuration(service.duration)} minutes
            </span>
          </div>

          {/* Price */}
          {service.price && (
            <div className="flex items-center gap-2 text-slate-300">
              <DollarSign className="w-4 h-4 text-emerald-400" />
              <span className="font-medium">
                {formatPrice(service.price)}
              </span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default PartnerServiceDetailsCardShadcn;